import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import React, { useEffect, useState, useMemo } from "react";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPaginationServerSide";
import nodeinstance from "../../../../nodeInstance";
import { CgSpinner } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import DropDownList from "../../../../ReusableComponents/DropDownList/DropDownList";
import UploadFilePopUp from "../../../../ReusableComponents/UploadFile/uplaodFile";
import FilterTab from "../../../../ReusableComponents/FilterDropDown/FilterTab";
import { AiOutlineClose } from "react-icons/ai";
import UploadFilePopUp_New from "../../../../ReusableComponents/UploadFile/UploadFileNew";

export default function ListDataOnArrivalMedical({
  titles = [],
  list = [],
  token,
  updateList,
  fetchData,
}) {
  //select Date
  const [statusData, setstatusData] = useState("");
  const [medicalApplicationDate, setMedicalApplicationDate] = useState("");

  const [date, setDate] = useState("");
  const [changedValues, setChangedValues] = useState();
  const [medicalDpendency, setMedicalDependency] = useState();
  const [medicalStatus, setMedicalStatus] = useState();
  const [searchActive, setSearchActive] = useState(false);
  const [searchResults, setSearchResults] = useState([]);

  const setMedicalDependencyValue = (event) => {
    setMedicalDependency(event.target.value);
    console.log("value ", event.target.value);
  };

  const medicalStatusValue = (event) => {
    setMedicalStatus(event.target.value);
    console.log("value ", event.target.value);
  };

  const [searchWords, setSearchWords] = useState([]);
  const [editingIndex, setEditingIndex] = React.useState();
  const [inputValue, setInputValue] = React.useState();
  const [Popup, setPopUp] = useState(false);

  const dispatch = useDispatch();

  const paginationMeta = useMemo(
    () => ({
      page: list?.meta?.page || 1,
      limit: list?.meta?.limit || 50,
      totalPages: list?.meta?.totalPages || 1,
      totalCount: list?.meta?.total || list?.data?.length || 0,
    }),
    [
      list?.meta?.page,
      list?.meta?.limit,
      list?.meta?.totalPages,
      list?.meta?.total,
      list?.data?.length,
    ]
  );

  useEffect(() => {
    if (!searchActive) {
      setSearchResults(list?.data || []);
    }
  }, [list, searchActive]);

  const activeData = searchActive ? searchResults : list?.data || [];
  const activeMeta = searchActive
    ? {
        page: 1,
        limit: activeData?.length || 50,
        totalPages: 1,
        totalCount: activeData?.length || 0,
      }
    : paginationMeta;

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    currentList,
  } = useSearchPagination(
    activeData,
    activeMeta,
    searchActive ? undefined : fetchData,
    ""
  );
  const apiCall = () => {
    updateList("");
  };

  //edit text Field
  const handleEdit = (index, initialValue) => {
    setEditingIndex(index);
    setInputValue(initialValue);
  };

  const formatDate = (dateString) => {
    if (dateString) {
      var date = new Date(dateString);
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var formattedDate = year + "-" + month + "-" + day;
      console.log(dateString, formattedDate);
      return formattedDate;
    }
  };

  const [downloadLoading, setDownloadLoading] = useState(false);
  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/employees/downloadOnArrivalMedicalExcel`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `OnArrivalMedical`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const update = async (type) => {
    if (type.medical_status === "UNFIT") {
      dispatch(
        setAppError({
          msg: "Medically unfit cannot be processed",
          // color: "success",
        })
      );
      return;
    }
    try {
      const res = await nodeinstance.post(
        "/employees/updateMedicalInfo",
        type,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(res);
      if (res.status == 200) {
        setEditingIndex(-1);
        apiCall();
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.data.error,
        })
      );
    }
  };

  const handleKeyDown = (event) => {
    event.preventDefault(); // Prevent typing in the input field
  };

  const getData = async (keyword) => {
    console.log(keyword.length);
    try {
      if (keyword.length >= 3) {
        const response = await nodeinstance.get(
          `employees/ArrivalSearch?keyword=${keyword}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setSearchActive(true);
        setSearchResults(response?.data?.data || []);
      } else if (keyword.length == 0) {
        setSearchActive(false);
        setSearchResults(list?.data || []);
        updateList();
      }
    } catch (error) {
      dispatch(setAppError({ msg: `${error?.message}` }));
    }
  };

  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => setPopUp(true)}
          >
            <p>Upload List</p>
            {/* {downloadLoading && <CgSpinner className="animate-spin" />} */}
          </button>
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => downloadFile()}
            disabled={downloadLoading || list?.isLoading}
          >
            <p>Download</p>
            {downloadLoading && <CgSpinner className="animate-spin" />}
          </button>
          <input
            type="search"
            className={`input input-sm h-10 max-w-xs pl-6 w-full input-bordered focus:outline-none uppercase`}
            placeholder={"enter search emp id"}
            onChange={(e) => {
              var dataValue = e.target.value;
              getData(dataValue);
            }}
          />
        </div>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <div className="relative bg-white">
          <div className="overflow-x-auto max-h-[70vh] ">
            <div className="sticky top-0 z-10 bg-white min-w-[4850px]">
              <div className="grid grid-cols-table-onArrivalMedical gap-5 p-6 text-center">
                {titles.map((t, index) => (
                  <p
                    key={index}
                    className={`font-semibold uppercase min-w-[70px] bg-white text-center ${
                      t === "EMPLOYEE ID" ? "sticky left-0 z-20 bg-white" : ""
                    }`}
                  >
                    {t}
                  </p>
                ))}
              </div>
            </div>
            <div className="sticky top-0 z-10 bg-white min-w-[4850px]">
              <div className="grid grid-cols-table-onArrivalMedical gap-5 p-6 bg-white text-center">
                {list?.isLoading && (
                  <LoadingWithLable className="col-span-full" />
                )}
                {!list?.isLoading && <NoDataFound />}
                {!list?.isLoading &&
                  currentList.map((list, index) => (
                    <React.Fragment key={index}>
                      <PaginationIndex index={index} />
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.point_of_hire || "-"}
                        />
                      </p>
                      <p className="font-semibold sticky left-1 z-10 bg-white">
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.employee_id || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_provider || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.Client_Name || "-"}
                        />
                      </p>

                      <p className="overflow-x-hidden">
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.sponsor_id || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.name || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_reference_number || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_stamping_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_block_number || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.border_number || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.passport_number || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.nationality || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.actual_profession || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_professions || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_profession_Arabic || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.arrival_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.dob || "-"}
                        />
                      </p>
                      {editingIndex === index ? (
                        <input
                          onKeyDown={handleKeyDown}
                          type="date"
                          defaultValue={formatDate(
                            list?.medical_application_date
                          )}
                          id="field2"
                          name="field2"
                          placeholder="Select Transaction Date"
                          className="border-[1px] border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs w-full"
                          onChange={(e) =>
                            setMedicalApplicationDate(e.target.value)
                          }
                          required
                        />
                      ) : (
                        <p>{list.medical_application_date}</p>
                      )}
                      <p>
                        {editingIndex === index ? (
                          <DropDownList
                            value={list.medical_status}
                            presetValues={[
                              // { value: "PENDING" },
                              { value: "FIT" },
                              { value: "UNFIT" },
                            ]}
                            setValue={medicalStatusValue}
                          />
                        ) : (
                          <p>{list.medical_status || "-"}</p>
                        )}
                      </p>

                      {editingIndex === index ? (
                        <input
                          onKeyDown={handleKeyDown}
                          type="date"
                          defaultValue={formatDate(list?.medical_status_date)}
                          id="field2"
                          name="field2"
                          placeholder="Enter Transaction Date"
                          className="border-[1px] border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs w-full"
                          onChange={(e) => setstatusData(e.target.value)} // Set onChange handler
                          required
                          size="sm"
                          selected={date}
                        />
                      ) : (
                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={list.medical_status_date || "-"}
                          />
                        </p>
                      )}
                      {/* list */}
                      <p>
                        {editingIndex === index ? (
                          <DropDownList
                            value={list.medical_dependency}
                            setValue={setMedicalDependencyValue}
                            presetValues={[
                              { value: "SLA" },
                              { value: "CLIENT" },
                              { value: "GR" },
                              { value: "LOCAL TRANSFER" },
                            ]}
                          />
                        ) : (
                          <p>{list.medical_dependency || "-"}</p>
                        )}
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.medical_arrival_status || "-"}
                        />
                      </p>
                      <div className="">
                        <button
                          title="Not Allowed"
                          className={
                            list.medical_arrival_status_value.toString() !==
                              "1" || editingIndex === index
                              ? "Save"
                                ? "px-2 rounded-md  bg-green-500 text-white text-xs p-2 w-20"
                                : "bg-red px-2 rounded-md text-white text-xs p-2 w-20"
                              : "bg-red px-2 rounded-md text-white text-xs p-2 w-20"
                          }
                          onClick={() => {
                            if (editingIndex === index) {
                              update({
                                employeeId: list.employee_id,
                                medical_application_date:
                                  medicalApplicationDate,
                                medical_status: medicalStatus,
                                medical_status_date: statusData,
                                medical_dependency: medicalDpendency,
                              });
                            } else {
                              handleEdit(index, list.medical_status_date);
                              setstatusData(list.medical_status_date);
                              setMedicalDependency(list.medical_dependency);
                              setMedicalApplicationDate(
                                list?.medical_application_date
                              );
                              setMedicalStatus(list.medical_status);
                            }
                          }}
                        >
                          {editingIndex === index
                            ? "Save"
                            : list.medical_arrival_status_value.toString() ===
                                "1"
                              ? "Update"
                              : "Edit"}
                        </button>
                        {editingIndex === index ? (
                          <button
                            className="ml-4"
                            onClick={() => {
                              setEditingIndex(-1);
                            }}
                          >
                            <AiOutlineClose />
                          </button>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div>
                        {editingIndex === index ? (
                          <button
                            className="ml-4"
                            onClick={() => {
                              setEditingIndex(-1);
                            }}
                          >
                            <AiOutlineClose />
                          </button>
                        ) : (
                          <></>
                        )}
                      </div>
                      <hr
                        className={`border-[1.5px] border-slate-100 w-full col-span-full `}
                      />
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <Pagination />
      </div>
      {Popup ? (
        <UploadFilePopUp_New
          PopUp={Popup}
          setPopUp={setPopUp}
          callBack={apiCall}
          title={"Upload ON ARRIVAL MEDICAL"}
          url={"/employees/updateMedicalInfoFromExcel"}
        />
      ) : (
        ""
      )}
    </>
  );
}
